import React from 'react'
import { array, bool, number, object, string } from 'prop-types'
import VideoGridComponent from '@/component/Primitive/VideoGrid'

const VideoGrid = ({
  title,
  suffix,
  articles,
  slotName,
  background,
  viewAllCtaLink,
  keyValueTargeting,
  section,
  article,
  rowIndex,
  pageData
}) => {
  const { isDesktop } = pageData
  const formattedArticles = articles.results?.map((a, i) => ({
    id: a._id,
    title: a.headline,
    sell: a.sell,
    link: a.fullUrlPath,
    src: a.images?.thumbnail_widescreen_644?.[0]?.url,
    featured: a.featured,
    hashtags: a.tags && a.tags.map((t) => t.tag),
    category: a.category,
    rowIndex,
    articleIndex: i,
    isDesktop
  }))
  const advertProps = {
    suffix,
    slotName,
    size: '300x250',
    keyValueTargeting,
    alignment: 'right',
    article,
    section
  }

  return (
    <VideoGridComponent
      advertProps={advertProps}
      articles={formattedArticles}
      title={title}
      background={background}
      ctaUrl={viewAllCtaLink}
      pageData={pageData}
    />
  )
}

VideoGrid.propTypes = {
  title: string,
  suffix: string,
  articles: object,
  section: object,
  article: object,
  slotName: string,
  background: bool,
  viewAllCtaLink: string,
  keyValueTargeting: array,
  rowIndex: number,
  pageData: object
}

export default VideoGrid
